"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Auth_1 = __importDefault(require("./Auth"));
var Storage_1 = __importDefault(require("./Storage"));
var JWTMemory_1 = __importDefault(require("./JWTMemory"));
var Nhost = /** @class */ (function () {
    function Nhost() {
        this.base_url = null;
        this.app_initialized = false;
        this.use_cookies = false;
        this.JWTMemory = new JWTMemory_1.default();
    }
    Nhost.prototype.initializeApp = function (config) {
        this.base_url = config.base_url;
        this.app_initialized = true;
        this.use_cookies = config.use_cookies ? config.use_cookies : false;
        this.refresh_interval_time = config.refresh_interval_time || null; // 10 minutes (600 seconds)
        this.ssr = typeof window === "undefined";
        this.client_storage = this.ssr
            ? {}
            : config.client_storage || window.localStorage;
        this.client_storage_type = config.client_storage_type
            ? config.client_storage_type
            : "web";
    };
    Nhost.prototype.auth = function () {
        if (!this.app_initialized || !this.base_url) {
            throw "app is not initialized. Call nhost.initializeApp(config). Read more here: https://docs.nhost.io/libraries/nhost-js-sdk#setup.";
        }
        var config = {
            base_url: this.base_url,
            use_cookies: this.use_cookies,
            refresh_interval_time: this.refresh_interval_time,
            client_storage: this.client_storage,
            client_storage_type: this.client_storage_type,
            ssr: this.ssr,
        };
        return new Auth_1.default(config, this.JWTMemory);
    };
    Nhost.prototype.storage = function () {
        if (!this.app_initialized || !this.base_url) {
            throw "app is not initialized. Call nhost.initializeApp(config). Read more here: https://docs.nhost.io/libraries/nhost-js-sdk#setup.";
        }
        var config = {
            base_url: this.base_url,
            use_cookies: this.use_cookies,
        };
        return new Storage_1.default(config, this.JWTMemory);
    };
    return Nhost;
}());
exports.default = new Nhost();
//# sourceMappingURL=index.js.map